<rask-saved-search-filter-tabs (filterChanged)="onFilterChanged($event)"
    [webbinstallningarKey]="webbInstallningarSparadeKey"></rask-saved-search-filter-tabs>
@if (form) {
<form [formGroup]="form" (ngSubmit)="onSearch()">
    <div class="row flex-nowrap align-items-start">
        <rask-multi-selector
            class="col-2"
            label="Uppdragsgivare"
            [items]="uppdragsgivarList" bindLabel="namn"
            [searchFn]="uppdragsgivareSearchFn"
            [selected]="form.value.uppdragsgivare"
            formControlName="uppdragsgivare">
        </rask-multi-selector>
        <rask-multi-selector
            class="col-2"
            label="Transportforetag"
            [items]="transportforetagList" bindLabel="namn"
            [searchFn]="transportforetagSearchFn"
            [selected]="form.value.transportforetag"
            formControlName="transportforetag">
        </rask-multi-selector>
        <rask-datepicker
            class="col-2"
            label="Uppdaterat i Viol fr.o.m"
            formControlName="uppdateratViolFrom">
        </rask-datepicker>
        <rask-datepicker
            class="col-2"
            label="t.o.m"
            formControlName="uppdateratViolTom">
        </rask-datepicker>
        <rask-save-search-filter class="col-2"
            [filterData]="model"
            [webbinstallningarKey]="webbInstallningarSparadeKey"
            [maxSavedFilters]="9"></rask-save-search-filter>
    </div>
    <div class="row">
        <rask-selector
            class="col-2"
            label="Anskaffningsform"
            [values]="valbaraAnskaffningsformer"
            formControlName="anskaffningsform">
        </rask-selector>
        <rask-multi-selector
            class="col-2"
            label="Status"
            [items]="valbaraStatusar"
            bindLabel="value"
            bindValue="key"
            [viewFormatter]="statusViewFormatter"
            [formatter]="statusOutputFormatter"
            [searchFn]="statusSearchFn"
            [selected]="form.value.status"
            formControlName="status">
        </rask-multi-selector>
        <rask-radiobutton-group
            class="col-2"
            aid="behover_uppdatering"
            label="Behöver uppdateras Viol"
            [buttons]="activetypes"
            formControlName="isDirtyValue">
        </rask-radiobutton-group>
        <rask-datepicker
            class="col-2"
            label="Giltig"
            formControlName="giltigDatum">
        </rask-datepicker>
    </div>
    <div class="row">
        <rask-radiobutton-group
            class="col-2"
            aid="transportavslutad_radio"
            label="Transportavslutad"
            [buttons]="activetypes"
            formControlName="transportavslutadFormValue">
        </rask-radiobutton-group>
        <rask-radiobutton-group
            class="col-2"
            aid="transporttilldelad Radio"
            label="Transporttilldelad"
            [buttons]="activetypes"
            formControlName="transporttilldeladFormValue">
        </rask-radiobutton-group>
        <rask-radiobutton-group
            class="col-2"
            aid="grot_radio"
            label="Grot"
            [buttons]="activetypes"
            formControlName="grotFormValue">
        </rask-radiobutton-group>
        <rask-input class="col-2" formControlName="avtalsobjekt" label="Avtalsobjekt"></rask-input>
        <rask-submit-button class="col-1 mt-auto"
            aid="buttonCkarbetsorderSok"
            color="secondary">Sök
        </rask-submit-button>
        <rask-button
            class="col-1 mt-auto"
            aid="buttonExternarbetsorderRensa"
            (click)="rensaSokFilter()"
            negative
            color="secondary">
            Rensa
        </rask-button>
    </div>
</form>
}